const hex_chr: string[] = "0123456789abcdef".split("");

export default hex_chr;
